import { useQuery } from '@tanstack/react-query';
import { getChatList } from '@services/chat.service';

export const CHAT_LIST_QUERY_KEY = ['chat', 'list'];

export const useChatList = (params = {}) => {
    const { page = 1, limit = 50, enabled = true } = params;
    return useQuery({
        queryKey: [...CHAT_LIST_QUERY_KEY, { page, limit }],
        queryFn: () => getChatList({ page, limit }),
        enabled: !!enabled,
    });
};
